export const UserRole = {
  BUYER: 'BUYER',
  SELLER: 'SELLER',
  TRANSACTION_MANAGEMENT: 'TRANSACTION_MANAGEMENT',
};

export const DealerUserRoleName = {
  BUYER: 'Buyer',
  SELLER: 'Seller',
};

export const EmployeeUserRoleName = {
  BUYER: 'Buyer',
  SELLER: 'Seller',
  TRANSACTION_MANAGEMENT: 'Transaction management',
};
